import React from "react";
import { Link } from "react-router-dom";

export default function LandingPage() {
  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#f8fafc", color: "#1e293b", fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif" }}>
      {/* Header */}
      <header style={{ backgroundColor: "#ffffff", borderBottom: "1px solid #e2e8f0", position: "sticky", top: 0, zIndex: 10 }}>
        <div style={{ maxWidth: "1100px", margin: "0 auto", padding: "16px 24px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <span style={{ fontSize: "24px", fontWeight: "800", color: "#2563eb", letterSpacing: "-0.5px" }}>Phloz</span>
            <span style={{ fontSize: "14px", color: "#64748b", borderLeft: "1px solid #cbd5e1", paddingLeft: "12px" }}>Outreach & Communication Platform</span>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
            <Link to="/privacy" style={{ fontSize: "14px", color: "#64748b", textDecoration: "none" }}>Privacy Policy</Link>
            <Link to="/terms" style={{ fontSize: "14px", color: "#64748b", textDecoration: "none" }}>Terms</Link>
            <Link
              to="/login"
              style={{
                fontSize: "14px",
                fontWeight: "600",
                color: "#ffffff",
                backgroundColor: "#2563eb",
                padding: "8px 18px",
                borderRadius: "6px",
                textDecoration: "none"
              }}
            >
              Sign In
            </Link>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section style={{ maxWidth: "1100px", margin: "0 auto", padding: "60px 24px 40px", textAlign: "center" }}>
        <h1 style={{ fontSize: "44px", fontWeight: "800", color: "#0f172a", lineHeight: "1.2", marginBottom: "20px", letterSpacing: "-1px" }}>
          Intelligent Communication & Outreach Automation
        </h1>
        <p style={{ fontSize: "18px", color: "#475569", maxWidth: "780px", margin: "0 auto 32px", lineHeight: "1.6" }}>
          Phloz connects your business communication channels into a unified workspace. Manage personalized email outreach campaigns, track replies, and streamline customer follow-ups with enterprise-grade reliability.
        </p>
        <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
          <Link
            to="/login"
            style={{
              fontSize: "16px",
              fontWeight: "600",
              color: "#ffffff",
              backgroundColor: "#2563eb",
              padding: "12px 28px",
              borderRadius: "8px",
              textDecoration: "none"
            }}
          >
            Access Phloz Platform
          </Link>
          <Link
            to="/privacy"
            style={{
              fontSize: "16px",
              fontWeight: "600",
              color: "#2563eb",
              backgroundColor: "#eff6ff",
              border: "1px solid #bfdbfe",
              padding: "12px 24px",
              borderRadius: "8px",
              textDecoration: "none"
            }}
          >
            View Privacy Policy
          </Link>
        </div>
      </section>

      {/* Purpose & Features Section */}
      <section style={{ maxWidth: "1100px", margin: "0 auto", padding: "40px 24px" }}>
        <h2 style={{ fontSize: "28px", fontWeight: "700", color: "#0f172a", textAlign: "center", marginBottom: "36px" }}>
          Application Purpose & Core Capabilities
        </h2>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: "24px" }}>
          <div style={{ backgroundColor: "#ffffff", padding: "28px", borderRadius: "10px", border: "1px solid #e2e8f0" }}>
            <h3 style={{ fontSize: "18px", fontWeight: "700", color: "#0f172a", marginBottom: "10px" }}>
              📧 Automated Email Outreach
            </h3>
            <p style={{ color: "#475569", fontSize: "14px", lineHeight: "1.6" }}>
              Connect your Google Workspace or Gmail account via secure OAuth to send targeted, scheduled outreach sequences directly from your own business email domain.
            </p>
          </div>

          <div style={{ backgroundColor: "#ffffff", padding: "28px", borderRadius: "10px", border: "1px solid #e2e8f0" }}>
            <h3 style={{ fontSize: "18px", fontWeight: "700", color: "#0f172a", marginBottom: "10px" }}>
              🔄 Reply Detection & Thread Sync
            </h3>
            <p style={{ color: "#475569", fontSize: "14px", lineHeight: "1.6" }}>
              Phloz continuously synchronizes campaign thread states to detect recipient responses, automatically pausing subsequent follow-up messages once an email is answered.
            </p>
          </div>

          <div style={{ backgroundColor: "#ffffff", padding: "28px", borderRadius: "10px", border: "1px solid #e2e8f0" }}>
            <h3 style={{ fontSize: "18px", fontWeight: "700", color: "#0f172a", marginBottom: "10px" }}>
              📊 Deliverability & Health Monitoring
            </h3>
            <p style={{ color: "#475569", fontSize: "14px", lineHeight: "1.6" }}>
              Monitor mailbox warmup, DNS records (SPF, DKIM, DMARC), bounce rates, and sending limits to preserve sender reputation and protect mailbox longevity.
            </p>
          </div>
        </div>
      </section>

      {/* Google API Compliance & Limited Use Section */}
      <section style={{ maxWidth: "1100px", margin: "20px auto 40px", padding: "0 24px" }}>
        <div style={{ backgroundColor: "#f0fdf4", border: "1px solid #86efac", borderRadius: "12px", padding: "32px", color: "#166534" }}>
          <h2 style={{ fontSize: "22px", fontWeight: "700", color: "#166534", marginBottom: "14px" }}>
            Google APIs Terms of Service & Limited Use Compliance
          </h2>
          <p style={{ fontWeight: "600", color: "#15803d", marginBottom: "12px", fontSize: "15px" }}>
            Phloz's use and transfer to any other app of information received from Google APIs adheres to the{" "}
            <a
              href="https://developers.google.com/terms/api-services-user-data-policy"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#15803d", textDecoration: "underline", fontWeight: "700" }}
            >
              Google API Services User Data Policy
            </a>
            , including the Limited Use requirements.
          </p>
          <ul style={{ paddingLeft: "20px", fontSize: "14px", lineHeight: "1.7", color: "#166534" }}>
            <li style={{ marginBottom: "8px" }}>
              <strong>User-Facing Features Only:</strong> Google user data is only accessed to provide user-facing features visible in the Phloz interface (initiating email campaigns, detecting replies, and updating thread statuses).
            </li>
            <li style={{ marginBottom: "8px" }}>
              <strong>No Generalized AI Model Training:</strong> We <strong>never</strong> use Google user data or email content to train, retrain, or fine-tune generalized, non-personalized artificial intelligence (AI) or machine learning (ML) models.
            </li>
            <li style={{ marginBottom: "8px" }}>
              <strong>No AI Non-Consensual Intimate Imagery (NCII):</strong> Phloz strictly complies with the Google APIs Terms of Service and Developer Policy. Phloz is an enterprise B2B sales outreach and communication automation service. We strictly prohibit and do not use Google APIs or AI services to create, process, generate, host, or distribute Non-Consensual Intimate Imagery (NCII) or harmful content.
            </li>
            <li style={{ marginBottom: "8px" }}>
              <strong>No Advertising & No Sale of Data:</strong> We do not sell or transfer Google user data to third parties, nor do we use Google user data for advertising purposes.
            </li>
          </ul>
        </div>
      </section>

      {/* Footer */}
      <footer style={{ backgroundColor: "#ffffff", borderTop: "1px solid #e2e8f0", padding: "32px 24px", marginTop: "60px" }}>
        <div style={{ maxWidth: "1100px", margin: "0 auto", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "16px" }}>
          <div>
            <span style={{ fontSize: "18px", fontWeight: "700", color: "#2563eb" }}>Phloz</span>
            <p style={{ fontSize: "13px", color: "#64748b", margin: "4px 0 0" }}>© 2026 Phloz by TBP Labs. All rights reserved.</p>
          </div>
          <div style={{ display: "flex", gap: "20px", fontSize: "14px" }}>
            <Link to="/privacy" style={{ color: "#64748b", textDecoration: "none" }}>Privacy Policy</Link>
            <Link to="/terms" style={{ color: "#64748b", textDecoration: "none" }}>Terms of Service</Link>
            <Link to="/login" style={{ color: "#2563eb", textDecoration: "none", fontWeight: "500" }}>Log In</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
